import React from 'react';
import Modal from 'react-modal';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '40vw',
        maxWidth: '40vw',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        border: '0px',
        background: '',
        padding: "3px 3px",
        textAlign: "center",
        backgroundSize: "100% 100%",
        alignItems: "center",
        overflow: "hidden",

    },
    overlay: {
        zIndex: 900,
    }
};

const AppModal = ({isOpen, className, handleClose, handleAfterOpen, handleCloseModal, contents, propsStyle}) =>
    (<div className={className}>
        <Modal
            isOpen={isOpen}
            ariaHideApp={false}
            onAfterOpen={handleAfterOpen}
            onRequestClose={handleCloseModal}
            style={propsStyle ? propsStyle : customStyles}

        >{contents}</Modal>
    </div>);

export default AppModal;